import { History } from 'history';
import { connect } from '~/store';

/** Store helper: provides the browser history, which can be managed to simulate changing URLs. */
export default (component: any): (props: any) => any => (
  connect(({ history }: { history: History }) => ({ history }))(component)
);
